import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage';
import UsersPage from './pages/UsersPage';
import DevicesPage from './pages/DevicesPage';
import UserDevicesPage from './pages/UserDevicesPage';
import ClanOruzje from './pages/ClanOruzje';
import ClanKerovi from './pages/ClanKerovi';
import ClanOdlikovanja from './pages/ClanOdlikovanja';
import ClanProfil from './pages/ClanProfil';
import OnlineDevicesPage from './pages/OnlineDevicesPage';
import TestPage from './pages/TestPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardAppPage from './pages/DashboardAppPage';

import CreateCompany from './pages/CompanyCRUDPages/create';
import ReadCompany from './pages/CompanyCRUDPages/read';
import UpdateCompany from './pages/CompanyCRUDPages/update';
import UpdateCompanyPhoto from './pages/CompanyCRUDPages/updatephoto';

import CreateZone from './pages/ZoneCRUDPages/create';
import ReadZone from './pages/ZoneCRUDPages/read';
import UpdateZone from './pages/ZoneCRUDPages/update';
import UpdateZonePhoto from './pages/ZoneCRUDPages/updatephoto';

import CreateLamp from './pages/LampCRUDPages/create';
import ReadLamp from './pages/LampCRUDPages/read';
import UpdateLamp from './pages/LampCRUDPages/update';
import UpdateLampPhoto from './pages/LampCRUDPages/updatephoto';

import CreateBuilding from './pages/BuildingCRUDPages/create';
import ReadBuilding from './pages/BuildingCRUDPages/read';
import UpdateBuilding from './pages/BuildingCRUDPages/update';
import UpdateBuildingPhoto from './pages/BuildingCRUDPages/updatephoto';

import CreateWorker from './pages/WorkerCRUDPages/create';
import ReadWorker from './pages/WorkerCRUDPages/read';
import UpdateWorker from './pages/WorkerCRUDPages/update';
import UpdateWorkerPhoto from './pages/WorkerCRUDPages/updatephoto';

import CreateLightingMode from './pages/LightingModeCRUDPages/create';
import ReadLightingMode from './pages/LightingModeCRUDPages/read';
import UpdateLightingMode from './pages/LightingModeCRUDPages/update';
import PreviewLightingMode from './pages/LightingModeCRUDPages/preview';

import CreateAlarm from './pages/AlarmCRUDPages/create';
import ReadAlarm from './pages/AlarmCRUDPages/read';
import UpdateAlarm from './pages/AlarmCRUDPages/update';

import Login from './components/Login';
import Profile from "./components/Profile";
import Register from "./components/Register";

import BuildingsReportAll from "./components/BuildingsReportAll";
import LampsListAll from "./components/LampsListAll";
import ZonesListAll from "./components/ZonesListAll";
import LightingModesListAll from "./components/LightingModesListAll";
import WorkersListAll from "./components/WorkersListAll";
import BuildingsListAll from "./components/BuildingsListAll";
import AlarmsListAll from "./components/AlarmsListAll";
import ReportsListAll from "./components/ReportsListAll";
import CompaniesListAll from "./components/CompaniesListAll";

import ChangePassword from "./components/ChangePassword";

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    { path: '/login', element: <Login /> },
	{ path: '/profile', element: <Profile /> },
	{ path: '/register', element: <Register /> },

{ path: '/company/create', element: <CreateCompany /> },
{ path: '/company/read', element: <ReadCompany /> },
{ path: '/company/update/', element: <UpdateCompany /> },
{ path: '/company/updatephoto/', element: <UpdateCompanyPhoto /> },
	
{ path: '/zone/create', element: <CreateZone /> },
{ path: '/zone/read', element: <ReadZone /> },
{ path: '/zone/update/', element: <UpdateZone /> },
{ path: '/zone/updatephoto/', element: <UpdateZonePhoto /> },

{ path: '/lamp/create', element: <CreateLamp /> },
{ path: '/lamp/read', element: <ReadLamp /> },
{ path: '/lamp/update/', element: <UpdateLamp /> },
{ path: '/lamp/updatephoto/', element: <UpdateLampPhoto /> },

{ path: '/building/create', element: <CreateBuilding /> },
{ path: '/building/read', element: <ReadBuilding /> },
{ path: '/building/update/', element: <UpdateBuilding /> },
{ path: '/building/updatephoto/', element: <UpdateBuildingPhoto /> },

{ path: '/worker/create', element: <CreateWorker /> },
{ path: '/worker/read', element: <ReadWorker /> },
{ path: '/worker/update/', element: <UpdateWorker /> },
{ path: '/worker/updatephoto/', element: <UpdateWorkerPhoto /> },

{ path: '/alarm/create', element: <CreateAlarm /> },
{ path: '/alarm/read', element: <ReadAlarm /> },
{ path: '/alarm/update/', element: <UpdateAlarm /> },

{ path: '/lightingmode/create', element: <CreateLightingMode /> },
{ path: '/lightingmode/read', element: <ReadLightingMode /> },
{ path: '/lightingmode/update/', element: <UpdateLightingMode /> },
{ path: '/lightingmode/preview/', element: <PreviewLightingMode /> },

{ path: '/settings/change-password', element: <ChangePassword /> },

	
    { path: '/dashboard', element: <DashboardLayout />,
        children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'users', element: <UsersPage /> },
		{ path: 'LampsListAll', element: <LampsListAll /> },
		{ path: 'ZonesListAll', element: <ZonesListAll /> },
		{ path: 'LightingModesListAll', element: <LightingModesListAll /> },
		{ path: 'WorkersListAll', element: <WorkersListAll /> },
		{ path: 'BuildingsListAll', element: <BuildingsListAll /> },
		{ path: 'AlarmsListAll', element: <AlarmsListAll /> },
    { path: 'ReportsListAll', element: <ReportsListAll /> },
		{ path: 'CompaniesListAll', element: <CompaniesListAll /> },
		{ path: 'BuildingsReportAll', element: <BuildingsReportAll /> },
		{ path: 'devices', element: <DevicesPage /> },
		{ path: 'userdevices', element: <UserDevicesPage vlasnik="212" /> },
		{ path: 'clanoruzje', element: <ClanOruzje vlasnik="5" /> },
		{ path: 'clankerovi', element: <ClanKerovi vlasnik="5" /> },
		{ path: 'clanodlikovanja', element: <ClanOdlikovanja vlasnik="5" /> },
		{ path: 'clanprofil', element: <ClanProfil vlasnik="2" /> },
		{ path: 'online_devices', element: <OnlineDevicesPage /> },
		{ path: 'test', element: <TestPage /> },
        { path: 'products', element: <ProductsPage /> },
        { path: 'blog', element: <BlogPage /> },
        ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
